<div class="container">
  <p class="title">
    Port Performance <mat-icon class="titleIcon">chevron_right</mat-icon> Request Form
    <mat-icon class="titleIcon">chevron_right</mat-icon>
  </p>
  <br>
  <div class="text-right">
    <input
      type="file"
      hidden
      #requestformFileInput
      (change)="onRequestformFileSelected($event)"
      accept=".xlsx, .xls , .xlsm, .csv"
    />
    <!-- <button
      class="btn btn-light hover-button mail"
      (click)="optimizationClick()"
    >
      <mat-icon>tune</mat-icon> &nbsp;Optimization
    </button> -->

    <button class="btn btn-light hover-button mail" (click)="clearClick()">
      <mat-icon>clear_all</mat-icon> &nbsp;Clear
    </button>
    <button class="btn btn-light hover-button mail" (click)="submitClick()">
      <mat-icon>done</mat-icon> Submit
    </button>
    <!-- <button class="btn btn-light hover-button mail" (click)="viewReport()">
      <mat-icon>visibility</mat-icon>
      View Report
    </button>
    <button
      class="btn btn-light hover-button mail"
      (click)="openRetrievePopup()"
    >
      <mat-icon>restore</mat-icon>
      Retrieve
    </button> -->
    <button
      class="btn btn-light hover-button mail w-auto"
      (click)="openUploadPopup()"
    >
      <mat-icon>upload_file</mat-icon>
      Download Report
    </button>
  </div>
  <div class="bgv">
    <form [formGroup]="requestForm">
      <div class="row fevenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color"></span>Pic:</label>
        </div>

        <div class="col-md-8 textBox">
          <div class="row">
            <!-- MerakiPic -->
            <div class="col-md-6">
              <label for=""><span class="asterik-color"></span>Meraki:</label>
              <select
                formControlName="merakiPic"
                class="form-control"
                [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('merakiPic')?.hasError('required'),
                }"
              >
                <option
                  *ngFor="
                    let option of merakiPicOptions;
                    even as isEven;
                    odd as isOdd
                  "
                  [ngValue]="option.value"
                  [ngClass]="{ odd: isOdd, even: isEven }"
                >
                  {{ option.label }}
                </option>
              </select>
              <small
                class="error"
                *ngIf="
                  formSubmitted &&
                  requestForm.get('merakiPic')?.hasError('required')
                "
              >
                <p class="ename">Meraki Pic is required.</p>
              </small>
            </div>

            <!-- ClientPic -->
            <div class="col-md-6">
              <label for="">Customer:</label>
              <select
                formControlName="clientPic"
                class="form-control"
                [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('clientPic')?.hasError('required'),
                }"
              >
                <option
                  *ngFor="
                    let option of eigerPicOptions;
                    even as isEven;
                    odd as isOdd
                  "
                  [ngValue]="option.value"
                  [ngClass]="{ odd: isOdd, even: isEven }"
                >
                  {{ option.label }}
                </option>
              </select>
              <small
                class="error"
                *ngIf="
                  formSubmitted &&
                  requestForm.get('clientPic')?.hasError('required')
                "
              >
                <p class="ename">Customer is required.</p>
              </small>
            </div>
            <div class="uploadIcon">
              <mat-icon
                class="upload-icon ml-2"
                (click)="requestformFileInput.click()"
                matTooltip="Upload File"
                >cloud_upload</mat-icon
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color"></span>Ship:</label>
        </div>
        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-4">
              <label class="repotedWeatherLabel">Ship Name</label>
              <app-custom-input
                [controlname]="this.requestForm.controls['vesselName']"
                [errorMessage]="'Ship Name is required'"
                [formSubmitted]="formSubmitted"
                [readonly]="isUpload"
              ></app-custom-input>
            </div>
            <div class="col-md-4">
              <label class="repotedWeatherLabel">I.M.O Number</label>
              <app-custom-input
                [errorMessage]="'IMO Numberis required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['imoNumber']"
                [readonly]="isUpload"
              ></app-custom-input>
            </div>
            <div class="col-md-4">
              <label class="repotedWeatherLabel">Segment</label>
              <!-- <app-custom-dropdown
                [items]="segmentOptions"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['segment']"
                [readonly]="isUpload"
              ></app-custom-dropdown> -->
              <select
                class="form-control"
                formControlName="segment"
                [disabled]="isUpload"
              >
                <option value="" disabled>Select</option>
                <option *ngFor="let opt of segmentOptions" [value]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="addIcon">
            <mat-icon
              class="add-icon"
              (click)="sisterShipClick()"
              matTooltip="Add the Sister Ship"
              >add</mat-icon
            >
          </div>
        </div>
      </div>
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color"></span>Ship Yard:</label>
        </div>
        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-4">
              <label class="repotedWeatherLabel">Ship Yard</label>
              <app-custom-input
                [errorMessage]="' ShipYard is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['shipYard']"
                [readonly]="isUpload"
              ></app-custom-input>
            </div>

            <div class="col-md-4">
              <label class="repotedWeatherLabel">Year Built</label>
              <app-custom-input
                [errorMessage]="'Year Built  is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['Yearbuilt']"
                [readonly]="isUpload"
              ></app-custom-input>
            </div>
            <div class="col-md-4">
              <label class="repotedWeatherLabel">Type of ship</label>
              <app-custom-input
                [errorMessage]="' type of ship is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['typeOfShip']"
                [readonly]="isUpload"
              ></app-custom-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color"></span>Report Type:</label>
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="reportTypeOptions"
            [controlname]="this.requestForm.controls['reportType']"
          ></app-custom-radio-button>
        </div>
      </div>
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color"></span>Ports:</label>
        </div>
        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-4">
              <label class="repotedWeatherLabel">To</label>
              <input
                type="text"
                class="form-control"
                formControlName="portName"
                (input)="filterPortNames($event)"
                [matAutocomplete]="auto"
              />

              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onPortSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let suggestion of portNameSuggestions"
                  [value]="suggestion"
                >
                  {{ suggestion }}
                </mat-option>
              </mat-autocomplete>

              <small
                class="error"
                *ngIf="
                  formSubmitted &&
                  requestForm.get('portName')?.hasError('required')
                "
              >
                <p class="ename">Port Name is required.</p>
              </small>
            </div>

            <div class="col-md-4" *ngIf="requestForm.get('reportType')?.value !== 'Port'">
              <label class="repotedWeatherLabel">From</label>
              <app-custom-dropdown
                [items]="fromOptions"
                [formSubmitted]="formSubmitted"
                [requiredErrorMessage]="'From is required'"
                [controlname]="requestForm.controls['pfrom']"
              >
              </app-custom-dropdown>
            </div>

            <!-- <div class="col-md-4">
              <label class="repotedWeatherLabel">To</label>
              <input
                type="text"
                class="form-control"
                id="to"
                formControlName="pto"
                [readonly]="requestForm.get('reportType')?.value === 'Port'"
              />
            </div> -->
            <div class="addIcon">
              <mat-icon
                class="add-icon"
                (click)="addClick()"
                matTooltip="Add Port"
                >add</mat-icon
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color"></span>Client Name:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-dropdown
            [items]="clientOptions"
            [formSubmitted]="formSubmitted"
            [requiredErrorMessage]="' Client is required'"
            [controlname]="this.requestForm.controls['client']"
          >
          </app-custom-dropdown>

          <div class="addIcon">
            <mat-icon
              class="add-icon"
              (click)="addClientClick(); $event.stopPropagation()"
              matTooltip="Add New Client"
            >
              add
            </mat-icon>
          </div>
        </div>
      </div>
      <!-- <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""> ECA:</label>
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNo"
            [controlname]="this.requestForm.controls['eca']"
          ></app-custom-radio-button>
        </div>
      </div> -->
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color"></span>Fuel Type Used:</label
          >
        </div>

        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-4">
              <app-custom-dropdown
                [placeholder]="
                  requestForm.controls['fuelType'].value
                    ? null
                    : 'HSFO/VLSFO/ULSFO'
                "
                [items]="fuelType"
                [requiredErrorMessage]="'Fuel Type is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['fuelType']"
              ></app-custom-dropdown>
            </div>
            <div class="col-md-4">
              <app-custom-dropdown
                [placeholder]="
                  requestForm.controls['fuelTypeOne'].value ? null : 'GO/MDO'
                "
                [items]="fuelType"
                [requiredErrorMessage]="'Fuel Type is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['fuelTypeOne']"
              ></app-custom-dropdown>
            </div>
            <div class="col-md-4">
              <app-custom-dropdown
                [placeholder]="
                  requestForm.controls['fuelTypeTwo'].value ? null : 'OTHERS'
                "
                [items]="fuelType"
                [requiredErrorMessage]="'Fuel Type is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['fuelTypeTwo']"
              ></app-custom-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""> Vessel Fitted with EGCS:</label>
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNo"
            [controlname]="this.requestForm.controls['vesselFitted']"
          ></app-custom-radio-button>
        </div>
      </div>
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""> Bunker Operation:</label>
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNo"
            [controlname]="this.requestForm.controls['bunkerOperataion']"
          ></app-custom-radio-button>
        </div>
      </div>
      <!-- Statement of Facts (SOF) Row (Direct Upload) -->
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""> Statement of Facts (SOF):</label>
        </div>
        <div class="col-md-8 textBox">
          <div class="file-upload-container align-items-center">
            <input
              type="file"
              hidden
              #sofFileInput
              (change)="onSofFileSelected($event)"
              accept=".pdf, .xlsx, .xls, .doc, .docx, .png, .jpg, .jpeg"
            />
            
            <!-- Upload Icon -->
            <mat-icon
              class="upload-icon pointer mr-2"
              (click)="sofFileInput.click()"
              matTooltip="Upload SOF Attachment"
            >cloud_upload</mat-icon>

            <span class="file-name" *ngIf="sofFileName">
                {{ sofFileName }}
                <mat-icon
                  class="view-icon text-primary align-middle pointer ml-2"
                  (click)="reopenParsedDataModal('SOF')"
                  matTooltip="View Extracted SOF Data"
                >visibility</mat-icon>
                <mat-icon
                  class="delete-icon text-danger align-middle pointer ml-1"
                  (click)="removeSofFile(sofFileInput)"
                  matTooltip="Remove file"
                >close</mat-icon>
              </span>
          </div>
          <!-- <small class="text-muted d-block mt-1 fs-12" *ngIf="!sofFileName">
            Allowed formats: PDF, Excel, Word, Image (Max 10MB)
          </small> -->
          <small class="error d-block" *ngIf="sofFileError">
            {{ sofFileError }}
          </small>
        </div>
      </div>

      <!-- Pumping Log Row (Direct Upload) -->
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""> Pumping Log:</label>
        </div>
        <div class="col-md-8 textBox">
          <div class="file-upload-container align-items-center">
            <input
              type="file"
              hidden
              #pumpingLogFileInput
              (change)="onPumpingLogFileSelected($event)"
              accept=".pdf, .xlsx, .xls, .doc, .docx, .png, .jpg, .jpeg"
            />

            <!-- Upload Icon -->
            <mat-icon
              class="upload-icon pointer mr-2"
              (click)="pumpingLogFileInput.click()"
              matTooltip="Upload Pumping Log Attachment"
            >cloud_upload</mat-icon>

            <span class="file-name" *ngIf="pumpingLogFileName">
                {{ pumpingLogFileName }}
                <mat-icon
                  class="view-icon text-primary align-middle pointer ml-2"
                  (click)="reopenParsedDataModal('PUMPING_LOG')"
                  matTooltip="View Extracted Pumping Log Data"
                >visibility</mat-icon>
                <mat-icon
                  class="delete-icon text-danger align-middle pointer ml-1"
                  (click)="removePumpingLogFile(pumpingLogFileInput)"
                  matTooltip="Remove file"
                >close</mat-icon>
              </span>
          </div>
          <!-- <small class="text-muted d-block mt-1 fs-12" *ngIf="!pumpingLogFileName">
            Allowed formats: PDF, Excel, Word, Image (Max 10MB)
          </small> -->
          <small class="error d-block" *ngIf="pumpingLogFileError">
            {{ pumpingLogFileError }}
          </small>
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color"></span>Bunker Grade & Quantity:</label
          >
        </div>
        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-2">
              <label class="repotedWeatherLabel">Bunker Grade 1</label>
              <app-custom-dropdown
                [items]="bunkerGradeOptions1"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['quaBunkerGradeOne']"
              ></app-custom-dropdown>
            </div>

            <div class="col-md-2">
              <label class="repotedWeatherLabel">Quantity 1 Mt </label>
              <app-custom-input
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['quantityOne']"
                (onInput)="onVoyageChange($event, 'quantityOne')"
              ></app-custom-input>
            </div>
            <div class="col-md-2">
              <label class="repotedWeatherLabel">Bunker Grade 2</label>
              <app-custom-dropdown
                [items]="bunkerGradeOptions2"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['quaBunkerGradeTwo']"
              ></app-custom-dropdown>
            </div>

            <div class="col-md-2">
              <label class="repotedWeatherLabel">Quantity 2 Mt </label>
              <app-custom-input
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['quantityTwo']"
                (onInput)="onVoyageChange($event, 'quantityTwo')"
              ></app-custom-input>
            </div>
            <div class="col-md-2">
              <label class="repotedWeatherLabel">Bunker Grade 3</label>
              <app-custom-dropdown
                [items]="bunkerGradeOptions3"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['quaBunkerGradeThree']"
              ></app-custom-dropdown>
            </div>

            <div class="col-md-2">
              <label class="repotedWeatherLabel">Quantity 3 Mt </label>
              <app-custom-input
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['quantityThree']"
                (onInput)="onVoyageChange($event, 'quantityThree')"
              ></app-custom-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>
            <span class="asterik-color"></span>
            Bunker discrepancy<mat-icon
              [matTooltip]="
                '+ve if Bunker survey ROB is more than Actual Bunker ROB  -ve if Bunker survey ROB is less than Actual Bunker ROB'
              "
              matTooltipClass="custom-tooltip"
            >
              info </mat-icon
            >:
          </label>
        </div>

        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-2">
              <label class="repotedWeatherLabel">Bunker Grade 1</label>
              <app-custom-dropdown
                [items]="bunkerGradeOptions1"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['disBunkerGradeOne']"
                [readonly]="requestForm.get('bunkerOperataion')?.value === 'NO'"
              ></app-custom-dropdown>
            </div>

            <div class="col-md-2">
              <label class="repotedWeatherLabel">Quantity 1 Mt </label>
              <app-custom-input
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['disNumericValueOne']"
                (onInput)="onVoyageChange($event, 'disNumericValueOne')"
                [readonly]="requestForm.get('bunkerOperataion')?.value === 'NO'"
              ></app-custom-input>
            </div>
            <div class="col-md-2">
              <label class="repotedWeatherLabel">Bunker Grade 2</label>
              <app-custom-dropdown
                [items]="bunkerGradeOptions2"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['disBunkerGradeTwo']"
                [readonly]="requestForm.get('bunkerOperataion')?.value === 'NO'"
              ></app-custom-dropdown>
            </div>

            <div class="col-md-2">
              <label class="repotedWeatherLabel">Quantity 2 Mt </label>
              <app-custom-input
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['disNumericValueTwo']"
                (onInput)="onVoyageChange($event, 'disNumericValueTwo')"
                [readonly]="requestForm.get('bunkerOperataion')?.value === 'NO'"
              ></app-custom-input>
            </div>
            <div class="col-md-2">
              <label class="repotedWeatherLabel">Bunker Grade 3</label>
              <app-custom-dropdown
                [items]="bunkerGradeOptions3"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['disBunkerGradeThree']"
                [readonly]="requestForm.get('bunkerOperataion')?.value === 'NO'"
              ></app-custom-dropdown>
            </div>

            <div class="col-md-2">
              <label class="repotedWeatherLabel">Quantity 3 Mt</label>
              <app-custom-input
                [formSubmitted]="formSubmitted"
                [controlname]="
                  this.requestForm.controls['disNumericValueThree']
                "
                (onInput)="onVoyageChange($event, 'disNumericValueThree')"
                [readonly]="requestForm.get('bunkerOperataion')?.value === 'NO'"
              ></app-custom-input>
            </div>
          </div>
        </div>
      </div>
      <div formArrayName="otherOperations">
        <div
          class="row oddBgv"
          [ngClass]="{ 'dark-odd': isDarkMode() }"
          *ngFor="let group of otherOperations.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="col-md-4">
            <label
              ><span class="asterik-color"></span>Any Other Operation:</label
            >
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-6">
                <label class="repotedWeatherLabel">Operation</label>
                <app-custom-dropdown
                  [items]="anyotherOperations"
                  [formSubmitted]="formSubmitted"
                  [requiredErrorMessage]="'Any Other Operation is required'"
                  [controlname]="group.get('anyOtherOperations')"
                ></app-custom-dropdown>
              </div>
              <div class="col-md-2">
                <label class="repotedWeatherLabel">Hours</label>
                <input
                  placeholder="HH"
                  type="number"
                  class="form-control time"
                  step="0.01"
                  formControlName="operationHours"
                  (input)="validateHours($event)"
                  [ngClass]="{
                    'error-border':
                      formSubmitted &&
                      group.get('operationHours')?.hasError('required'),
                  }"
                />
              </div>

              <div class="col-md-4">
                <label class="repotedWeatherLabel">Status</label>
                <app-custom-dropdown
                  [items]="statusOptions"
                  [formSubmitted]="formSubmitted"
                  [requiredErrorMessage]="'Type of Operation is required'"
                  [controlname]="group.get('status')"
                ></app-custom-dropdown>
              </div>

              <div class="addIcon">
                <mat-icon
                  class="add-icon"
                  *ngIf="
                    i === otherOperations.length - 1 &&
                    otherOperations.length < 3
                  "
                  (click)="addRow()"
                  matTooltip="Add Row"
                  >add_circle_outline</mat-icon
                >

                <mat-icon
                  class="remove-icon"
                  *ngIf="otherOperations.length > 1"
                  (click)="removeRow(i)"
                  matTooltip="Remove Row"
                  >remove_circle_outline</mat-icon
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""> ECA Region:</label>
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNo"
            [controlname]="this.requestForm.controls['ecaRegion']"
          ></app-custom-radio-button>
        </div>
      </div>
      <!-- <div class="row oddBgv datesBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span *ngIf="datesValidator" class="asterik-color"></span
            >Dates:</label
          >
        </div>

        <div class="col-md-8 textBox1">
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-6">
                  <label class="repotedWeatherLabel">COSP</label>
                  <app-custom-date-picker
                    [errorMessage]="'COSP is required'"
                    [formSubmitted]="formSubmitted"
                    [controlname]="this.requestForm.controls['cosp']"
                  ></app-custom-date-picker>
                </div>
                <div class="col-md-6">
                  <div class="time-picker">
                    <input
                      placeholder="HH"
                      type="number"
                      id="hour"
                      class="form-control time"
                      min="0"
                      max="24"
                      formControlName="cospHours"
                      (input)="restrictInput($event.target, 24)"
                      [ngClass]="{
                        'error-border':
                          formSubmitted &&
                          requestForm.get('cospHours')?.hasError('required')
                      }"
                    />

                    <input
                      placeholder="MM"
                      type="number"
                      id="minute"
                      class="form-control time"
                      min="0"
                      max="59"
                      formControlName="cospMinutes"
                      (input)="restrictInput($event.target, 59)"
                      [ngClass]="{
                        'error-border':
                          formSubmitted &&
                          requestForm.get('cospMinutes')?.hasError('required')
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-6">
                  <label class="repotedWeatherLabel">EOSP</label>
                  <app-custom-date-picker
                    [errorMessage]="'EOSP is required'"
                    [formSubmitted]="formSubmitted"
                    [controlname]="this.requestForm.controls['eosp']"
                  ></app-custom-date-picker>
                </div>
                <div class="col-md-6">
                  <div class="time-picker">
                    <input
                      placeholder="HH"
                      type="number"
                      id="hour"
                      class="form-control time"
                      min="0"
                      max="24"
                      formControlName="eospHours"
                      (input)="restrictInput($event.target, 24)"
                      [ngClass]="{
                        'error-border':
                          formSubmitted &&
                          requestForm.get('eospHours')?.hasError('required')
                      }"
                    />

                    <input
                      placeholder="MM"
                      type="number"
                      id="minute"
                      class="form-control time"
                      min="0"
                      max="59"
                      formControlName="eospMinutes"
                      (input)="restrictInput($event.target, 59)"
                      [ngClass]="{
                        'error-border':
                          formSubmitted &&
                          requestForm.get('eospMinutes')?.hasError('required')
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span *ngIf="datesValidator" class="asterik-color"></span>Other
            Fields:</label
          >
        </div>
        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-2">
              <label class="repotedWeatherLabel">Type Of Operations</label>
              <app-custom-dropdown
                [items]="typeofOperations"
                [formSubmitted]="formSubmitted"
                [requiredErrorMessage]="' Type of Operation is required'"
                [controlname]="this.requestForm.controls['typeOfOperations']"
              ></app-custom-dropdown>
            </div>
            <div class="col-md-2">
              <label class="repotedWeatherLabel">Cargo Quantity (M³)</label>
              <input
                type="number"
                class="form-control"
                id="cargoQuantity"
                formControlName="cargoQuantity"
              />
            </div>
            <div class="col-md-2">
              <label class="repotedWeatherLabel">COP RPM</label>
              <input
                type="number"
                class="form-control"
                id="pumpRPM"
                formControlName="pumpRPM"
              />
            </div>
            <div class="col-md-2">
              <label class="repotedWeatherLabel">No of COP running</label>
              <input
                type="number"
                class="form-control"
                id="no_of_pump"
                formControlName="no_of_pump"
              />
            </div>
            <div class="col-md-2">
              <label class="repotedWeatherLabel">A/E TCP (mt)</label>
              <input
                type="number"
                class="form-control"
                id="ae_tcp"
                formControlName="ae_tcp"
              />
            </div>
            <div class="col-md-2">
              <label class="repotedWeatherLabel">Min Tol on Fuel Cons/MT</label>
              <input
                type="number"
                class="form-control"
                id="fuelMinTol"
                formControlName="fuelMinTol"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row evenLastBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for="">Any Additional Comments:</label>
        </div>
        <div class="col-md-8 textarea">
          <textarea
            id="additionalComments"
            name="additionalComments"
            class="form-control"
            formControlName="additionalComments"
          ></textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="topClick()">
      <mat-icon>arrow_upward</mat-icon> &nbsp;Go top
    </button>
    <button class="btn btn-light hover-button mail" (click)="clearClick()">
      <mat-icon>clear_all</mat-icon> &nbsp;Clear
    </button>
    <button class="btn btn-light hover-button mail" (click)="submitClick()">
      <mat-icon>done</mat-icon> Submit
    </button>
  </div>
  <br />
</div>
